export default __webpack_public_path__ + "400f28a224470806acf261c8538b4362.png";